import { render, staticRenderFns } from "./TransferInfo.html?vue&type=template&id=484d21c2&"
import script from "./TransferInfo.js?vue&type=script&lang=js&"
export * from "./TransferInfo.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports